module.exports = __webpack_public_path__ + "static/media/29.04ea4438.jpg";